import useQuestionHeading from '../../hooks/useQuestionHeading'

/**
 * De kop boven één grafiek van een onderzoek in een live rapportage. Een eigen
 * component omdat de kop per vraag een opzoeking is (een hook), en
 * ResearchVisualization de vragen in een lus tekent.
 *
 * @param {object} props
 * @param {object} props.field - QuestionnaireFields-document
 */
const ResearchFieldHeading = ({ field }) => {
    const text = useQuestionHeading(field)

    if (!text) return null

    return <h3 className="question-widget-title">{text}</h3>
}

export default ResearchFieldHeading
